import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { HTVPlatform } from '../../../platforms/platform'
import { PlatformService } from '../../../platforms/platform.service'

@Component({
  selector: 'app-channel-player',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './channel-player.component.html',
  styleUrls: ['./channel-player.component.scss'],
})
export class ChannelPlayerComponent implements OnInit {
  platformType!: HTVPlatform
  HTVPlatform = HTVPlatform

  constructor(private platformService: PlatformService) {
    // do nothing
  }

  ngOnInit(): void {
    this.platformType = this.platformService.type
  }
}
